import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Elements, StripeProvider} from 'react-stripe-elements';
import { createPosOrder, getPosConfig } from '../../actions/pos';
import { createAppointment, bookMemberToAppointment} from "../../actions/appointments";
import viewHelper from '../../helpers/view';
import Spinner from '../shared/spinner';
import SelectCategory from './selectCategory';
import SelectProduct from './selectProduct';
import CreditCard from './creditCard';
import PosOrder from './posOrder';
import CartModal from './cartModal';
import MemberInfo from '../shared/memberInfo';
import StripeError from './stripeError';
import CacheService from '../../services/cacheService';

class Sales extends Component {

    constructor(props) {
        super(props);
        this.state = {
            appointment: null,
            category: null,
            cart: null,
            checkout: false,
            credit_card: null, // conflicts with CreditCard Component
            showCart: false
        };
    }

    componentDidMount() {
        let appointment = CacheService.getAppointment();
        if(appointment) {
            this.setState({appointment: appointment, activity: {id: appointment.activity_id}}, () => {
                CacheService.removeAppointment();
            })
        }
        this.props.getPosConfig(this.props.member.site_id);
    }

    updateComponent(state) {
        if(state.credit_card) {
            let appointmentDate = this.state.appointment && this.state.appointment.date ? this.state.appointment.date : null;
            this.props.createPosOrder({ cart: this.state.cart, credit_card: state.credit_card, appointment_date: appointmentDate}).then(() => {
                // Order created along with membership. If necessary create appointment/ book appointment.
                if(this.state.appointment) {
                    if(this.state.appointment.id) {
                        // Scheduler was used
                        this.props.bookMemberToAppointment(this.state.appointment.id, this.state.activity.id, this.props.history);
                    } else {
                        // Book appointment was used
                        this.props.createAppointment(this.state.appointment, this.props.history);
                    }
                }
            });
        }
        return this.setState(state);
    }

    checkout() {
        this.setState({ checkout: true, showCart: false, credit_card: null })
    }

    toggleCart() {
        this.setState({showCart: !this.state.showCart});
    }

    getSelectedComponent() {
        if (!this.state.appointment && !this.state.category && !this.state.checkout){
            return SelectCategory;
        } else if((this.state.appointment || this.state.category) && !this.state.checkout) {
            return SelectProduct;
        } else if (this.state.cart && this.state.checkout && !this.state.credit_card) {
            return CreditCard;
        } else {
            return SelectProduct;
        }
    }

    render () {
        if(this.props.posOrder) {
            return <PosOrder {...this.props} appointment={this.state.appointment} />;
        } else if(this.props.spinner) {
            return (
                <div className='container content'>
                    <Spinner />
                </div>
            )
        } else if(this.props.stripeApiKey) {
            const { member, posOrder, currency, stripeApiKey, stripeAccountId } = this.props;
            let SelectedComponent = this.getSelectedComponent();
            const stripe = window.Stripe(this.props.stripeApiKey, { stripeAccount: this.props.stripeAccountId })
            return (
                <div className="container content">
                    <MemberInfo title={`${viewHelper.getFullName(member)} - Buy Products`} />
                    <StripeProvider stripe={stripe}>
                        <div className="col-xs-12 col-md-12 col-lg-12 no-padding">
                            <div className="col-xs-12 col-md-12 col-lg-12 no-padding border-bottom">
                                <Elements>
                                    <SelectedComponent
                                        {...this.state}
                                        checkout={this.checkout.bind(this)}
                                        toggleCart={this.toggleCart.bind(this)}
                                        posOrder={posOrder}
                                        member={member}
                                        currency={currency}
                                        callbackToUpdateComponent={this.updateComponent.bind(this)} />
                                </Elements>
                                <CartModal cart={this.state.cart} show={this.state.showCart} onHide={this.toggleCart.bind(this)}
                                           currency={this.props.currency} checkout={this.checkout.bind(this)}/>
                            </div>
                        </div>
                    </StripeProvider>
                </div>
            );
        } else {
            return (
              <div className='container content'>
                  <StripeError />
              </div>
            )
        }
    }
}

function mapStateToProps(state) {
    const { posOrder, posConfig, spinner } = state;
    return {
        posOrder,
        spinner,
        stripeApiKey: posConfig.publishable_key,
        stripeAccountId: posConfig.connected_account_id,
        currency: posConfig.currency
    };
}

export default connect(mapStateToProps, { getPosConfig, createPosOrder, bookMemberToAppointment, createAppointment })(Sales);
